import Vue from 'vue';
import Router from 'vue-router';
import Specials from './views/Specials.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:arkona/:type',
            name: 'specials',
            component: Specials,
            props: true,
        },
    ],
});
